export default __webpack_public_path__ + "images/b45e5b90eea6decb0c1bdfb1e59c153c-bridal.webp";